var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFoldedCard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.59 65",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M23.61 31.75c-2.56 0-4.64-2.08-4.64-4.64s2.08-4.64 4.64-4.64 4.64 2.08 4.64 4.64-2.08 4.64-4.64 4.64Zm0-6.96c-1.28 0-2.32 1.04-2.32 2.32s1.04 2.32 2.32 2.32 2.32-1.04 2.32-2.32-1.04-2.32-2.32-2.32ZM24.77 45.68c-.3 0-.59-.11-.82-.34l-8.47-8.47-6.14 6.14c-.45.45-1.19.45-1.64 0-.45-.45-.45-1.19 0-1.64l6.96-6.96c.45-.45 1.19-.45 1.64 0l9.29 9.29c.45.45.45 1.19 0 1.64-.23.23-.52.34-.82.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M34.06 45.68c-.3 0-.59-.11-.82-.34L27.1 39.2l-3.82 3.82c-.45.45-1.19.45-1.64 0s-.45-1.19 0-1.64l4.64-4.64c.45-.45 1.19-.45 1.64 0l6.96 6.96c.45.45.45 1.19 0 1.64-.23.23-.52.34-.82.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M39.16 65H3.42C1.53 65 0 63.46 0 61.58V12.65c0-1.89 1.54-3.42 3.42-3.42h35.75c1.89 0 3.42 1.54 3.42 3.42v48.92c0 1.89-1.54 3.42-3.42 3.42ZM3.42 12.23c-.23 0-.42.19-.42.42v48.92c0 .23.19.42.42.42h35.75c.23 0 .42-.19.42-.42V12.65c0-.23-.19-.42-.42-.42H3.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M2.56 12.31c-.65 0-1.22-.43-1.4-1.06-.22-.77.22-1.58 1-1.81L34.66.06a1.452 1.452 0 0 1 1.87 1.4v9.28c0 .81-.66 1.46-1.46 1.46s-1.46-.66-1.46-1.46V3.4L2.97 12.24c-.13.04-.27.06-.41.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M2.56 12.01c-.5 0-.97-.33-1.11-.84-.18-.62.18-1.26.79-1.44L34.74.35a1.16 1.16 0 0 1 1.48 1.12v9.28a1.16 1.16 0 0 1-2.32 0V3.01L2.88 11.96c-.11.03-.22.05-.32.05ZM13.29 57.46h16a1.33 1.33 0 1 0 0-2.66h-16a1.33 1.33 0 1 0 0 2.66Z"
  })));
};
export default SvgIconFoldedCard;